import React from 'react';

import { CONFIG_ITEM_KEYS } from '../../config-items/config-item-keys';
import {
	type EditorPluginAIConfigItem,
	createEditorPluginAIConfigItemMarkdown,
} from '../../config-items/config-items';
import { Icon } from '../assets/icons/prefill';
import { createInsertAtCurrentPosition } from '../config-item-actions/markdown';

import { messages } from './messages';
import { PrefillPrompts } from './types';

const SELECTION_TYPE = 'empty';

export const configItemKeyRecord: Record<PrefillPrompts, CONFIG_ITEM_KEYS> = {
	[PrefillPrompts.BudgetPlanPrompt]: CONFIG_ITEM_KEYS.PREFILL_BUDGET_PLAN,
	[PrefillPrompts.CompetitiveAnalysisPrompt]: CONFIG_ITEM_KEYS.PREFILL_COMPETITIVE_ANALYSIS,
	[PrefillPrompts.DocumentationPrompt]: CONFIG_ITEM_KEYS.PREFILL_DOCUMENTATION,
	[PrefillPrompts.MarketingCampaignPrompt]: CONFIG_ITEM_KEYS.PREFILL_MARKETING_CAMPAIGN,
	[PrefillPrompts.OnboardingGuidePrompt]: CONFIG_ITEM_KEYS.PREFILL_ONBOARDING_GUIDE,
	[PrefillPrompts.ProsAndConsPrompt]: CONFIG_ITEM_KEYS.PREFILL_PROS_AND_CONS,
	[PrefillPrompts.SprintPlanningPrompt]: CONFIG_ITEM_KEYS.PREFILL_SPRINT_PLANNING,
};

// remove this when cleanup platform_editor_ai_remove_selection_type
export const createPrefillConfigItem = (prompt: PrefillPrompts) => {
	const key = configItemKeyRecord[prompt];
	const message = messages[prompt];
	return createEditorPluginAIConfigItemMarkdown({
		key,
		title: message,
		description: message,
		// remove this when cleanup platform_editor_ai_remove_selection_type
		selectionType: SELECTION_TYPE,
		icon: ({ shownAt }) => <Icon shownAt={shownAt} />,
		intentSchemaId: 'custom_free_generate_intent_schema.json',
		isVisible: ({ editorView }) => !(editorView.state.doc.nodeSize - 4),
		getBackendModel: () => 'assistance-service',
		disableInterrogation: () => false,
		// remove this when cleanup platform_editor_ai_remove_selection_type
		actions: [createInsertAtCurrentPosition({ appearance: 'primary' })],
		isPrefill: true,
	});
};

// remove this when cleanup platform_editor_ai_remove_selection_type
export const prefillConfigItems = [
	createPrefillConfigItem(PrefillPrompts.MarketingCampaignPrompt),
	createPrefillConfigItem(PrefillPrompts.ProsAndConsPrompt),
	createPrefillConfigItem(PrefillPrompts.CompetitiveAnalysisPrompt),
	createPrefillConfigItem(PrefillPrompts.DocumentationPrompt),
	createPrefillConfigItem(PrefillPrompts.OnboardingGuidePrompt),
	createPrefillConfigItem(PrefillPrompts.SprintPlanningPrompt),
	createPrefillConfigItem(PrefillPrompts.BudgetPlanPrompt),
];

const createPrefill = (prompt: PrefillPrompts): EditorPluginAIConfigItem => {
	const key = configItemKeyRecord[prompt];
	const message = messages[prompt];
	return {
		key,
		title: message,
		description: message,
		icon: ({ shownAt }) => <Icon shownAt={shownAt} />,
		isPrefill: true,
		disableInterrogation: () => false,
		intentSchemaId: 'custom_free_generate_intent_schema.json',
		getBackendModel: () => 'assistance-service',
		actions: {
			empty: [createInsertAtCurrentPosition({ appearance: 'primary' })],
		},
	};
};

export const prefills = [
	createPrefill(PrefillPrompts.MarketingCampaignPrompt),
	createPrefill(PrefillPrompts.ProsAndConsPrompt),
	createPrefill(PrefillPrompts.CompetitiveAnalysisPrompt),
	createPrefill(PrefillPrompts.DocumentationPrompt),
	createPrefill(PrefillPrompts.OnboardingGuidePrompt),
	createPrefill(PrefillPrompts.SprintPlanningPrompt),
	createPrefill(PrefillPrompts.BudgetPlanPrompt),
];

export const prefillWithOptions = prefills.map((config) => ({
	config,
	triggers: { empty: true, selection: false },
}));
